function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.52,
    height: 29.52,
    viewBox: "0 0 29.52 29.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "10.67 8.38 20.43 21.28 18.91 21.28 9.05 8.38 10.67 8.38",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,.24A14.76,14.76,0,1,0,29.76,15,14.76,14.76,0,0,0,15,.24Zm3.4,22.91-4.3-5.62L9.19,23.15H6.46l6.37-7.29L6.11,7.07h5.62l3.89,5.14,4.49-5.14h2.73l-6,6.81,7,9.27Z",
    transform: "translate(-0.24 -0.24)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.d0e7ee83c95ccf65b61268c496956dc8.svg";
export { ForwardRef as ReactComponent };